<div class="date-select">
  <div
    class="form-floating"
    [ngClass]="{
      touched: control?.touched,
      invalid: !control?.valid,
    }"
  >
    <input
      type="text"
      class="form-control"
      [(ngModel)]="innerValue"
      [minDate]="minDate"
      [maxDate]="maxDate"
      ngbDatepicker
      #datePicker="ngbDatepicker"
      (click)="datePicker.toggle()"
      (dateSelect)="writeValue($event)"
      [placeholder]="placeholder"
      [readonly]="readOnly"
      [disabled]="control?.disabled"
      autocomplete="off"
      (ngModelChange)="onDateChange($event)"
      id="date-select-input"
    />
    <button
      class="btn"
      (click)="datePicker.toggle()"
      [attr.aria-label]="ariaLabel"
      [disabled]="control?.disabled"
      id="date-select-button"
    >
      <span class="material-icons align-middle" aria-hidden="true">calendar_month</span>
    </button>
    <label for="date-select-input" *ngIf="label">{{ label }}</label>
  </div>
</div>
